import jwt from 'jsonwebtoken';
import moment from 'moment';

const JWT_STORAGE_KEY = 'catapult::sso';

export function addTokensLocalStorage(payload) {
  localStorage.setItem(JWT_STORAGE_KEY, JSON.stringify(payload));
}

export function removeTokensLocalStorage() {
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function hasTokensLocalStorage() {
  return !!localStorage.getItem(JWT_STORAGE_KEY);
}

export function getTokensLocalStorage() {
  const payload = localStorage.getItem(JWT_STORAGE_KEY);
  return JSON.parse(payload);
}

export function getIdTokenAndFavProductLocalStorage() {
  const payload = JSON.parse(localStorage.getItem(JWT_STORAGE_KEY));

  return {
    token: payload.id_token,
    favoriteProduct: payload.favoriteProduct,
  };
}

export function isJwtValid(token) {
  try {
    const decoded = jwt.decode(token);
    const currentDate = moment.unix(moment().unix());
    const issuedDate = moment.unix(decoded.iat);
    const expiryDate = moment.unix(decoded.exp);

    return (
      moment(currentDate).isSameOrAfter(issuedDate)
      && moment(currentDate).isSameOrBefore(expiryDate)
    );
  } catch (error) {
    return false;
  }
}
